 <template>
    <div class="container">
        <div class="content">
            <img class="tip_icon" src="../assets/img/egg_title.png" alt="">
            <div v-if="lotteryDetail.user_have_credit" class="currentCredit">
                <span>{{'当前积分：'+lotteryDetail.user_have_credit}}</span>
                <p v-if="lotteryDetail.credit_desc!=''">{{lotteryDetail.credit_desc}}</p>
            </div>
            <div id="boxArea">
                <div class="eggStage">
                    <div class="shape" ref="shape" :class="{active: actionSign}" :style="beatStyle.shape">
                        <div class="item one lottery-draw" @click="beat($event,1)">
                            <div class="eggshell" style="transform: rotateY(90deg);">
                                <div class="egg" ref="egg"
                                :style="[{backgroundImage: playState.egg1 ? `url(${imgArr[0]})` : `url(${imgArr[1]})`},beatStyle.egg]">
                                    <div class="hammer" :class="{hammeron: !playState.egg1}"></div>
                                </div>
                            </div>
                        </div>
                        <div class="item two lottery-draw" @click="beat($event,2)">
                            <div class="eggshell" style="transform: rotateY(210deg);">
                                <div class="egg"
                                :style="[{backgroundImage: playState.egg2 ? `url(${imgArr[0]})` : `url(${imgArr[1]})`},beatStyle.egg]">
                                    <div class="hammer" :class="{hammeron: !playState.egg2}"></div>
                                </div>
                            </div>
                        </div>
                        <div class="item three lottery-draw" @click="beat($event,3)">
                            <div class="eggshell" style="transform: rotateY(330deg);">
                                <div class="egg"
                                :style="[{backgroundImage: playState.egg3 ? `url(${imgArr[0]})` : `url(${imgArr[1]})`},beatStyle.egg]">
                                    <div class="hammer" :class="{hammeron: !playState.egg3}"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btnArea">
                    <!-- 您还剩余x次抽奖机会 -->
                    <div class="btn" @click="reset" :style="{backgroundColor: outSign ? '#ffed5d' : '#ea4816'}">再来一次</div>
                    <div class="tip">{{drawTip}}</div>
                </div>
            </div>

            <div class="award_btn">
                <p @click="clickAward">我的中奖记录</p>
            </div>
        </div>
        <section class="tip_text_container" v-if="lotteryDetail.show_desc=='1'"><!-- 奖品说明 -->
                <div class="tip_award">
                    <p>奖项说明</p>
                </div>
                <div class="awardList">
                    <ul class="lists">
                        <li class="list" v-for="(item,index) in prizeListData" :key="index">
                            <p class="awardPic" v-if="prizeListImgDisplay">
                                <img :src="item.image" alt="">
                            </p>
                            <p :class="prizeListImgDisplay?'pName':'pName_sec'">{{item.name}}</p>
                            <p :class="prizeListImgDisplay?'pDesc':'pDesc_sec'">{{item.desc}}</p>
                            <p :class="prizeListImgDisplay?'pSur':'pSur_sec'" v-if="lotteryDetail.show_prize_num=='1'">{{'剩余数量：'+item.prize_number}}</p>
                        </li>
                    </ul>
                </div>
        </section>
        <section class="tip_text_container"><!-- 活动说明 -->
                <div class="tip_award">
                        <p>活动说明</p>
                </div>
                <div class="awardList">
                  <div class="lists" v-if="lotteryDetail.about_lottery">
                      <p class="explain">
                        <pre>{{lotteryDetail.about_lottery}}</pre>
                      </p>
                  </div>
                  <div class="lists" v-else>
                      <p class="explain" v-html="lotteryDetail.desc"></p>
                  </div>
                </div>
        </section>
        <section class="foot">
            <div class="logo">
                <img :src="logo_img" alt="">
            </div>
        </section>
        <!-- 实物中奖弹窗 -->
        <formDialog
            :formDialogDisplay.sync="formDialogDisplay"
            :title="prizeReqData.msg"
            :id="prizeReqData.prize_receive_record_id"
            :formList="fillInfo"></formDialog>
        <div class="lostTip" v-if="lostTipDisplay">
            <div class="lostTip_content">
                <i class="el-icon-error" @click="lostTipDisplay = false"></i>
                <div class="lostTip_content_text">
                    {{lostTipMsg}}
                </div>
                <div class="lostTip_btn" @click="lostTipDisplay = false">确 定</div>
            </div>
        </div>
    </div>
</template>

<script> //type="text/ecmascript-6"
import FormDialog from 'components/formDialog/formDialog'

import sqBg from '../assets/images/lamp.png'
import sqBgGif from '../assets/images/lamp_active.gif'

import Slide from './slide'

import {prefixStyle} from '@/assets/js/tool'

const transform = prefixStyle('transform')

import {logo_img} from '../config/config';
    export default {
        data() {
            return {
                logo_img,
                formDialogDisplay: false,
                code: '',
                actionSign: true,
                playState: {
                    shape: true,
                    egg1: true,
                    egg2: true,
                    egg3: true
                },
                imgArr: [
                    require('../assets/img/egg.png'),
                    require('../assets/img/egg2.png'),
                    require('../assets/img/hit.png'),
                ],
                formLabelWidth: '30%',
                drawTip: '',
                outSign: false, // 抽奖机会用完啦
                formSureFlag: true, // 中奖表单提交锁
                beatTag: true,
                lostTipDisplay: false,
                dialogShow: false,  // 中奖表单显示开关
                dialogItemsState: { // 中奖表单的选项的状态
                    name: false,
                    tel: false,
                    idcard: false,
                    add: false
                },
                fillInfo: {}, // 中奖表单填写内容
                prizeReqData: {}, // 接收请求成功的数据
                beatStyle: {
                    shape: {},
                    egg: {}
                }
            }
        },
        props:['lotteryDetail','prizeListData', 'prizeListImgDisplay', 'preview', 'platRight', 'coordinate'],
        created() {
            // 初始化抽奖次数
            this.drawnumInit()
        },
        methods: {
          platRightCheck() {
            if (this.platRight && this.platRight.right === 0) {
              if (this.platRight.apptype === 'WX') {
                this.$router.push('/wxScan')
              } else {
                this.$dialog({
                  message: this.platRight.name,
                  url: this.platRight.url,
                  key: this.platRight.apptype
                })
              }
              return true
            }
          },
            drawnumInit() {
                let vm = this
                this.Get({
                    url:'/activity/api.php',
                    data: {
                        m:'front',
                        subm:'lottery',
                        action:'drawnum',
                        preview: vm.preview,
                    },
                    success:function(data){
                        if(data.code == 3001) {
                            if(data.data.no_limit == 0) {
                                if(data.data.residue_count > 0) {
                                    vm.drawTip = `您还剩余${data.data.residue_count}次抽奖机会`
                                }else{
                                    vm.drawTip = '抽奖机会用完啦！'
                                }
                            }
                            /* 更新积分 */
                            vm.lotteryDetail.user_have_credit = data.data.user_have_credit
                        }
                    },
                    error: function(data){

                    }
                });
            },
            reset() {
              // 端检查
              if (this.platRightCheck()) return
              for(let key in this.playState) {
                this.playState[key] = true
              }
              this.actionSign = true
              this.beatTag = true
            },
            beat(e, n) {
              // 端检查
              if (this.platRightCheck()) return
              // 没砸过继续，反之需要再来一次解封
              if(this.beatTag) {
                  // 关闭砸蛋入口
                  this.beatTag = false
                  this.beatEggStyle()
                  let egg = 'egg' + n
                  this.playState[egg] = false
                  this.eggReq()
              }
            },
            beatEggStyle() {
                this.beatStyle.shape.transform = this.getStyle(this.$refs.shape, 'transform')
                this.beatStyle.egg.transform = this.getStyle(this.$refs.egg, 'transform')
                this.actionSign = false
            },
            getStyle(el, key) {
                return el.currentStyle ? el.currentStyle[key] : document.defaultView.getComputedStyle(el, false)[key]
            },
            eggReq(){
                let vm = this
                let latitude, longitude
                if (this.coordinate) {
                  latitude = this.coordinate.latitude
                  longitude = this.coordinate.longitude
                }
                this.Get({
                    url: '/activity/api.php',
                    data: {
                        m: 'front',
                        subm: 'lottery',
                        action: 'drawprize',
                        preview: vm.preview,
                        lat: latitude || '',
                        lng: longitude || '',
                    },
                    success: function(data){
                        vm.drawnumInit()
                        if(data.code == 3001){
                            vm.prizeReqData = data.data
                            // 处理中奖的情况
                            vm.drawResult(vm.prizeReqData)

                            // 我直接用请求中的credit和credittype吧
                            // if(vm.prizeReqData.credit_type != 0 && vm.prizeReqData.credit != 0 && typeof(vm.lotteryDetail.user_have_credit) !== 'undefined'){
                            //     if(vm.prizeReqData.credit_type == 1){
                            //         vm.lotteryDetail.user_have_credit -= vm.lotteryDetail.credit;
                            //     }else if(data.data.credit_type == 2){
                            //         vm.lotteryDetail.user_have_credit += vm.lotteryDetail.credit;
                            //     }
                            // }
                            // 刷新抽奖次数提示
                            // 更新prizelist奖品数量信息等
                            if(data.data.prize_id != 0) {
                                vm.prizeListUpdate()
                            }
                        }
                    },
                    error: function(data){
                        if (data.code==5007||data.code == 5110||data.code==5011||data.code==5014||data.code==5020||data.code==5107) {
                            // vm.$router.replace('/');
                            // window.location.reload(true);
                        }
                        vm.lostTip(data.msg)
                        vm.drawnumInit()
                    }
                })

            },
            prizeListUpdate() {
                this.$emit('prizeListUpdateNotice')
            },
            drawResult(data){
                // prize_id不为0时中奖
                if(data.prize_id){
                    if(data.prize_type == 1 && data.receive_msg.length){
                        this.fields = {
                            m: 'front',
                            subm: 'lottery',
                            action: 'receivemsg',
                            id: data.prize_receive_record_id
                        }
                        for(let i=0;i<data.receive_msg.length;i++){
                            let item = data.receive_msg[i]
                            this.fillInfo[item] = ''
                        }
                        // 打开中奖表单弹窗
                        this.formDialogDisplay = true;
                    }else if(data.prize_type === 3){
                        this.alertPrize(data.msg, '立即领取', data.prize_url)
                    } else {
                        this.resultTip(data)
                    }
                }else{
                    this.resultTip(data)
                }
            },
            showField(data){
                if (data.hasOwnProperty("nickname")) {
                    this.dialogItemsState.name = true;
                }
                if (data.hasOwnProperty("telephone")) {
                    this.dialogItemsState.tel = true;
                }
                if (data.hasOwnProperty("idcard")) {
                    this.dialogItemsState.idcard = true;
                }
                if (data.hasOwnProperty("address")) {
                    this.dialogItemsState.add = true;
                }
                this.dialogShow = true;
            },
            resultTip(data){
                // 注释是因为verification是undefined，导致报网络异常的错误

                // let msgChange = ''
                // if(verification){
                //     msgChange = data.msg + '<br>' + data.invented_prize_info.verification
                // }else{
                //     msgChange = data.msg
                // }
                // this.alertPrize(msgChange)
                this.lostTip(data.msg)
            },
            lostTip(msg){
                this.lostTipDisplay = true
                this.lostTipMsg = msg
            },
            clickAward() {
              // 端检查
              if (this.platRightCheck()) return
              this.$emit('clickAward')
            },
            getRandom(min, max) {
                let range = max - min
                return min + Math.round(Math.random() * range)
            },
          alertPrize(){//中奖后的弹框
              this.$emit.apply(this,[].concat.apply(['alertPrize'], arguments));
          },
        },
        components: {
            Slide,
            FormDialog
        }
    }
</script>

<style scoped lang="stylus">
    .lostTip{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        z-index: 999;
        .lostTip_content{
            position: relative;
            width: 80%;
            // min-height: 10%;
            padding: 10% 0 5%;
            background-color: #fff;
            margin: 50% auto 0;
            .lostTip_content_text{
                width: 90%;
                min-height: 40px;
                // background-color: #ccc;
                margin: auto;
                margin-bottom: 30px;
            }
            .lostTip_btn{
                width: 40%;
                height: 30px;
                line-height: 30px;
                background-color: orange;
                margin: auto;
                border-radius: 4px;
                color: #fff;
            }
            & > i{
                color: #e21843;
                position: absolute;
                top: 0;
                right: 0;
                transform: translateX(50%) translateY(-50%);
                background-color: #fff;
                border-radius: 50%;
            }
        }
    }
    #boxMask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
    }
        .boxMask_codeArea{
            width: 90vw;
            height: 200px;
            margin: 150px auto 0;
            /* background: orange; */
            display: flex;
            justify-content: space-around;
        }
        .boxMask_closeBtn{
            position: absolute;
            top: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            background-color: red;
            border-radius: 50%;
            color: #fff;
            font-size: 20px;
            line-height: 30px;
        }
        .boxMask_submitBtn{
            width: 140px;
            height: 36px;
            line-height: 36px;
            border-radius: 6px;
            background-color: red;
            margin: 38px auto 0;
            color: #fff
        }
    .content{
        background-image: url('../assets/images/title_bg.png');
        background-size: 100% 100%;
    }
        #boxArea
            min-height: 100px
            .eggStage
                position: relative
                margin: 20px auto 40px
                // width: 300px
                width: 80%
                height: 200px
                // border: 1px solid #ccc
                perspective: 600px
                perspective-origin: center -300px
                @keyframes spin
                    0%
                        transform:rotateX(90deg) rotateZ(0deg)
                    100%
                        transform:rotateX(90deg) rotateZ(360deg)

                @keyframes spinEgg
                    0%
                        transform:rotateY(0deg)
                    100%
                        transform:rotateY(360deg)
                .shape
                    width: 0
                    height: 0
                    position: absolute
                    left: 50%
                    top: 40px
                    transform: rotateX(90deg)
                    transform-style: preserve-3d
                    backface-visibility: visible
                    // animation: spin 10s linear infinite
                    &.active
                        animation: spin 10s linear infinite
                        .egg
                            animation: spinEgg 10s linear infinite
                    .item
                        width: 0
                        height: 0
                        position: absolute
                        transform-style: preserve-3d
                        .eggshell
                            width: 0
                            height: 0
                            position:absolute
                            transform-style: preserve-3d
                            backface-visibility: visible
                            transform: rotateY(90deg)
                            .egg
                                position: relative
                                margin-left: -45px
                                // animation: spinEgg 10s linear infinite
                                // background: url('../assets/img/egg.png')
                                background-repeat: no-repeat
                                background-size: 100% 100%
                                width: 90px
                                height: 90px
                                .hammer
                                    opacity: 0
                                    position: absolute
                                    left: 60px
                                    top: -20px
                                    width: 36px
                                    height: 54px
                                    background: url('../assets/img/hit.png') no-repeat
                                    background-size: contain
                                    transform-origin: right bottom
                                    &.hammeron
                                        animation: hammer 0.3s ease-out
                                        animation-fill-mode: both
                                     @keyframes hammer
                                        0%
                                            opacity: 0
                                        100%
                                            opacity: 1
                                            transform: rotate(-45deg)
                                // &.on
                                //     animation: spinEgg 10s linear infinite
                    .one
                        transform: rotateZ(90deg) translateX(70px) rotateX(-90deg)
                    .two
                        transform: rotateZ(210deg) translateX(70px) rotateX(-90deg)
                    .three
                        transform: rotateZ(330deg) translateX(70px) rotateX(-90deg)
            .btnArea
                .btn
                    width: 148px
                    height: 36px
                    line-height: 36px
                    border-radius: 6px
                    // background-color: #ea4816
                    font-size: 18px
                    font-weight: 500
                    color: #fed218
                    margin: auto
                    margin-bottom: 10px
                .tip
                    color: #4a4a4a
    .tip_icon{
        width: 60%;
        margin: 15px auto;
    }
    .currentCredit{
        margin-bottom: 10px;
        color: #444e45;
    }
    #squareBox{
        width: 96vw;
        height: 96vw;
        margin: 0 auto;
        background: orange;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background: url(/static/image/lamp_active.gif); */
        background-size: 100% 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/smashEggs.vue